// src/components/content/RiskRegister.js
import { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, Divider, Typography } from '@mui/material';
import { useLocation, useParams } from 'react-router';
import { LoadingScreen } from 'src/components/loading-screen';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import Header from '../header';
import RenderField from '../../risk-register/render-field';
// import WeeklyViewDrawComp from './weekly-view-draw-comp';
import FinanceStatementViewTable from './finance-statement-view-table';
import { useRouter } from 'src/routes/hooks';

const FinanceStatementView = () => {
  const { id } = useParams();
  console.log('🚀 ~ PayrollViewpage ~ id:', id);
  const [loading, setLoading] = useState(false);
  const [createdby, setcreatedby] = useState([]);
  const [proectManager, setProjectManager] = useState([]);
  const [employeeOptions, setemployeeOptions] = useState([]);
  // const [riskOwnersOptions, setRiskOwnersOptions] = useState([]);

  const location = useLocation();
  const rowData = location?.state?.rowData;
  const router = useRouter();

  useEffect(() => {
    getProjects();
    getEmployeeName();
  }, []);

  const getProjects = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_project_list);
    console.log('🚀 ~ getProjets ~ data:', data);
    if (data) {
      //setprojectList(data);
    }
  };
  const getEmployeeName = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_employee_list);
    console.log('🚀 ~ getEmployeeName ~ data:', data);
    if (data) {
      setemployeeOptions(data);
    }
  };

  const departmentString = rowData?.department_division_filter;
  const formattedDepartments = departmentString[0].split(',').join(',\n');

  return (
    <>
      {loading ? (
        <Box height={700}>
          <LoadingScreen />
        </Box>
      ) : (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
            <Typography variant="h6" fontWeight="bold">
              FINANCE STATEMENT VIEW PAGE
            </Typography>
            <Button
              variant="contained"
              className="dark-button"
              // startIcon={<ArrowBackIcon />}
              onClick={() => router.back()}
            >
              Go Back
            </Button>
          </Box>
          <Card sx={{ height: '100%', marginTop: '10px', overflow: 'hidden', boxShadow: 3 }}>
            <CardContent>
              <Card sx={{ boxShadow: 6 }}>
                <Box
                  p={4}
                  mt={0}
                  display="grid"
                  gridTemplateColumns="repeat(3, 1fr)"
                  gap={3}
                  alignItems="center"
                  borderBottom="1px solid #ddd"
                  pb={2}
                >
                  <RenderField label="Statement Type" value={rowData?.statement_type || ''} />
                  <RenderField label="Reporting Period" value={rowData?.reporting_period || ''} />
                  <RenderField label="Company Entity" value={rowData?.company_entity || ''} />
                  <RenderField
                    label="Department Division Filter"
                    value={formattedDepartments || ''}
                  />
                  <RenderField label="Account Grouping" value={rowData?.account_grouping || ''} />
                  <RenderField
                    label="Include Subtotals By Category"
                    value={rowData?.include_subtotals_by_category?.toString() || ''}
                  />
                  <RenderField
                    label="Comparative Analysis"
                    value={rowData?.comparative_analysis?.toString() || ''}
                  />
                  <RenderField
                    label="Variance Analysis"
                    value={rowData?.variance_analysis?.toString() || ''}
                  />
                  <RenderField
                    label="Currency Selection"
                    value={rowData?.currency_selection || ''}
                  />
                  <RenderField label="Rounding Level" value={rowData?.rounding_level || ''} />
                  <RenderField label="Notes Annotations" value={rowData?.notes_annotations || ''} />
                  <RenderField
                    label="Auto Calculation of Ratios"
                    value={rowData?.auto_calculation_of_ratios?.toString() || ''}
                  />
                  <RenderField
                    label="Approval Workflow"
                    value={rowData?.approval_workflow?.toString() || ''}
                  />
                  <RenderField
                    label="Scheduled Generation"
                    value={rowData?.scheduled_generation?.toString() || ''}
                  />
                </Box>
              </Card>

              <Card sx={{ marginTop: '20px', boxShadow: 6 }}>
                <FinanceStatementViewTable data={rowData} />
              </Card>
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};
export default FinanceStatementView;
